export const isHomePage = () => {
  return document.body.classList.contains("home");
};
